import { render, staticRenderFns } from "./SingleView.vue?vue&type=template&id=793c0736&scoped=true&"
import script from "./SingleView.vue?vue&type=script&lang=js&"
export * from "./SingleView.vue?vue&type=script&lang=js&"
import style0 from "./SingleView.vue?vue&type=style&index=0&id=793c0736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793c0736",
  null
  
)

export default component.exports